import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { trmDtlApi, termListAPi, termModifyApi } from "components/api/term";
import TrmModifyView from "components/view/terms/modify";
import { prvProps } from "interface/term";
import i18n from "locales/i18n";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setMessage } from "store/commonSlice";

const TermModifyPage = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const langCd = i18n.language;
  const { pathname, search, state } = useLocation();
  const trmDtlMutation = useMutation(trmDtlApi, {
    onSuccess(data) {
      if (data) {
        const {
          header: { code, message },
          body,
        } = data;
        if (code === 0) {
        }
      }
    },
  });

  const prvDtl = trmDtlMutation?.data?.body?.prvDtl;

  const [prv, setPrv] = useState<prvProps>({
    // prvCd: state?.prvCd,
    langCd: langCd,
    prvNm: "",
    prvDesc: "",
    essYn: "",
    aplyYn: "",
    aplySDt: "",
    aplyEDt: "",
    trmCn: "",
    rgSeq: "",
    verNm: "",
    uyn: "",
  });

  const handleChange = (name: string, value: string) => {
    if (name.includes("trmCn")) {
      setPrv({
        ...prv,
        trmCn: value,
      });
      return;
    }
    setPrv({
      ...prv,
      [name]: value,
    });
  };

  const handleSelect = (target: EventTarget & HTMLLIElement) => {
    const { name, lng, value } = target.dataset;
    if (name && value) {
      setPrv({
        ...prv,
        [name]: value,
      });
    }
  };

  const termMutation = useMutation(termModifyApi, {
    onSuccess(data) {
      if (data) {
        const {
          header: { code, message },
          body,
        } = data;
        if (code === 0) {
          dispatch(
            setMessage({
              message: "성공적으로 약관을 수정하였습니다.",
              isConfirm: true,
              handleClick() {
                dispatch(setMessage({ message: null }));
                queryClient.invalidateQueries({ queryKey: ["termDtl"] });
              },
            })
          );
        }
        if (code === -1) {
          dispatch(setMessage({ message }));
        }
      }
    },
  });

  const handleModify = () => {
    const params = {
      ...prv,
      rgSeq: prvDtl?.rgSeq,
      verNm: prvDtl?.verNm,
      prvCd: prvDtl?.prvCd,
    };
    dispatch(
      setMessage({
        message: "약관내용을 수정하시겠습니까?",
        isConfirm: true,
        isCancel: true,
        handleClick() {
          termMutation.mutate(params);
          dispatch(setMessage({ message: null }));
        },
      })
    );
  };

  useEffect(() => {
    trmDtlMutation.mutate({
      langCd: state?.langCd ?? i18n.language,
      prvCd: search.replace("?prvCd=", ""),
    });
  }, []);

  useEffect(() => {
    setPrv({
      ...prv,
      trmCn: "",
    });
  }, []);

  return (
    <TrmModifyView
      isLoading={termMutation.isLoading}
      prv={prv}
      prvDtl={prvDtl}
      handleChange={handleChange}
      handleModify={handleModify}
      handleSelect={handleSelect}
    />
  );
};

export default TermModifyPage;
